// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { ItemDetail } from '@/items/api/types';
import { Box, FormControlLabel, Radio, Typography } from '@mui/material';

interface Props {
  primaryItem: ItemDetail;
  selectedItem: ItemDetail;
  selection: 'primary' | 'selected';
  onSelectionChange: (field: string, source: 'primary' | 'selected') => void;
}

export function BOMComparisonRow(props: Props) {
  const primaryHasBOM =
    props.primaryItem.bom && props.primaryItem.bom.length > 0;
  const selectedHasBOM =
    props.selectedItem.bom && props.selectedItem.bom.length > 0;
  const bothHaveNoBOM = !primaryHasBOM && !selectedHasBOM;

  return (
    <Box
      display="grid"
      gridTemplateColumns="2fr 2fr 2fr 3fr"
      sx={{
        borderBottom: '1px solid',
        borderColor: 'divider',
        px: 2,
        py: 2,
        alignItems: 'center',
      }}
    >
      <Typography variant="body2">Bill of materials</Typography>

      <Box sx={{ ml: bothHaveNoBOM ? 4 : -1 }}>
        {bothHaveNoBOM ? (
          <Typography variant="body2" color="text.secondary">
            Not set
          </Typography>
        ) : (
          <FormControlLabel
            control={
              <Radio
                checked={props.selection === 'primary'}
                onChange={() => props.onSelectionChange('bom', 'primary')}
                size="small"
                disabled={bothHaveNoBOM}
              />
            }
            label={
              primaryHasBOM ? (
                <Box component="ul" sx={{ m: 0, pl: 3 }}>
                  {props.primaryItem.bom?.map((bomItem, index) => (
                    <Box component="li" key={index}>
                      <Typography variant="body2" color="text.secondary">
                        {bomItem.item.name} (Qty: {bomItem.quantity})
                      </Typography>
                    </Box>
                  ))}
                </Box>
              ) : (
                <Typography variant="body2" color="text.secondary">
                  Not set
                </Typography>
              )
            }
            sx={{ alignItems: 'center', m: 0 }}
          />
        )}
      </Box>

      <Box sx={{ ml: bothHaveNoBOM ? 4 : -1 }}>
        {bothHaveNoBOM ? (
          <Typography variant="body2" color="text.secondary">
            Not set
          </Typography>
        ) : (
          <FormControlLabel
            control={
              <Radio
                checked={props.selection === 'selected'}
                onChange={() => props.onSelectionChange('bom', 'selected')}
                size="small"
                disabled={bothHaveNoBOM}
              />
            }
            label={
              selectedHasBOM ? (
                <Box component="ul" sx={{ m: 0, pl: 3 }}>
                  {props.selectedItem.bom?.map((bomItem, index) => (
                    <Box component="li" key={index}>
                      <Typography variant="body2" color="text.secondary">
                        {bomItem.item.name} (Qty: {bomItem.quantity})
                      </Typography>
                    </Box>
                  ))}
                </Box>
              ) : (
                <Typography variant="body2" color="text.secondary">
                  Not set
                </Typography>
              )
            }
            sx={{ alignItems: 'center', m: 0 }}
          />
        )}
      </Box>

      <Box>
        <Typography variant="body2" color="text.secondary">
          Not set
        </Typography>
      </Box>
    </Box>
  );
}
